// extracted by mini-css-extract-plugin
module.exports = {"details":"_1yxZ8","arrow":"_3asEM","contentWrapper":"_3bdhn","title":"_23zIq","categoryLink":"_3K54h","moreButton":"_1wmrL","statistics":"_16o87","buttonGroup":"_3oDSV"};